<div class="content p-4" cdkTrapFocus>
  <div class="d-flex flex-column text-center">
    <h4>{{'COMPONENT.NETWORK_STATUS.TITLE' | translate}}</h4>
    <p>{{'COMPONENT.NETWORK_STATUS.DESCRIPTION' | translate}}</p>
  </div>
</div>